import { queryOptions } from '@tanstack/react-query';

import { fetchPlayersById } from '@apis/players';

export const getPlayersByIdQuery = (params: Parameters<typeof fetchPlayersById>[0]) =>
  queryOptions({
    queryKey: ['players', params],
    queryFn: ({ signal }) => fetchPlayersById(params, signal),
    placeholderData: [],
  });
